// extracted by mini-css-extract-plugin
export default {"premiumTag":"styles_premiumTag__DVZ+A","positionAbsolute":"styles_positionAbsolute__Xkr6Z"};